
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Посредник</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>

      <ul class="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
        <li class="nav-item flex-fill" role="presentation">
          <button class="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Основни Данни</button>
        </li>
        <li class="nav-item flex-fill" role="presentation">
          <button class="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Услуги</button>
        </li>
      </ul>
      <div class="tab-content pt-2" id="borderedTabJustifiedContent">
        <div class="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab">
          <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
            <div class="col-12">
              <label for="agentName" class="form-label">Име</label>
              <input type="text" formControlName="agentName" class="form-control" id="agentName" value="{{editObject.agentName}}">
            </div>
            <div class="col-12">
              <label for="agentEIK" class="form-label">ЕИК</label>
              <input type="text" formControlName="agentEIK" class="form-control" id="agentEIK" value="{{editObject.agentEIK}}">
            </div>
            <div class="col-12">
              <label for="agentEIK" class="form-label">Основна Комисионна</label>
              <input type="text" formControlName="agentEIK" class="form-control" id="agentEIK" value="{{editObject.agentEIK}}">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
                <label class="form-check-label" for="isActive">Активна</label>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
            </div>
          </form>
        </div>
        <div class="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab">
          <div style="display: flex; justify-content: end;">
            <button type="button" style="margin-right: 10px;" class="btn btn-primary" (click)="onCreation()"><i class="bi bi-check-circle"></i> Добави</button>
            <button type="button" style="margin-right: 10px;" class="btn btn-warning" (click)="onEdit()"><i class="bi bi-exclamation-triangle"></i> Редактирай</button>
            <button type="button" class="btn btn-danger" (click)="onDelete()"><i class="bi bi-exclamation-octagon"></i> Изтриване</button>
          </div>
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px; margin-top: 20px;">
            <!-- Search input box -->
            <input type="text" [(ngModel)]="searchQuery" class="form-control" placeholder="Search..." style="flex: 1; margin-right: 10px;">

            <!-- Search button -->
            <button (click)="filterAgentServices()" class="btn btn-primary">Search</button>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">УРИ</th>
                <th scope="col">Име</th>
                <th scope="col">Услуга</th>
                <th scope="col">Комисионна</th>
                <th scope="col">Банкова сметка</th>
                <th scope="col">Активна</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let service of filteredAgentServices" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onUserSelected(service)">
                <td>{{service.service.yri}}</td>
                <td>{{service.title}}</td>
                <td>{{service.service.serviceName}}</td>
                <td>{{service.agentCommission}}</td>
                <td>{{getAccountDetails(service)}}</td>
                <td>{{service.isActive}}</td>
              </tr>

            </tbody>
          </table>

        </div>
      </div>


      </div>
    </div>

</ng-container>
